import React, { Component } from 'react';
import PropTypes from 'prop-types';
import each from 'lodash/each';
import cloneDeep from 'lodash/cloneDeep';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import autobind from 'class-autobind';

import FormUi from './form_ui.jsx';
import { assetPropType } from './prop_types.js';
import { FIELD_TYPE_MULTI_ANSWER, FIELD_TYPE_SHORT_ANSWER } from 'zoomforth_zf/models/form.js';

function getUserResponseFromState(state) {
  const userResponse = {};

  each(state.formValueByQuestionName, (formValue, questionName) => {
    userResponse[questionName] = formValue.value;
  });

  return userResponse;
}

function calcValidatedState(formId, state, forceValidation = false) {
  let hasErrors = false;
  const clonedState = cloneDeep(state);
  const formValueByQuestionName = clonedState.formValueByQuestionName;
  const formErrors = [];
  each(clonedState.questions, (question) => {
    const formValue = formValueByQuestionName[question.name];
    formValue.error = false;

    if (forceValidation) {
      formValue.isTouched = true;
    }

    if (formValue.isTouched && question.isRequired && isEmpty(formValue.value)) {
      formValue.error = true;
      hasErrors = true;

      formErrors.push({
        href: question.href,
        message: `"${question.label}" is required.`
      });
    }
  });

  clonedState.questions = map(clonedState.questions, (question) => {
    question.href = `form-${formId}-${question.name}`;
    return question;
  });

  return {
    ...clonedState,
    formErrors,
    formValueByQuestionName,
    hasErrors
  };
}

class GridTileInnerTypeForm extends Component {
  constructor(props) {
    super(props);

    this.state= this.getStateConfig(props.asset);

    autobind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.asset !== this.props.asset) {
      this.setState({...this.getStateConfig(this.props.asset)});
    } 
  }

  render() {
    const {
      asset,
      verticalAlign,
      horizontalAlign,
      headerHtml,
      formId,
      uniqueFormString
    } = this.props;

    const {
      isSubmitted,
      questions,
      formValueByQuestionName,
      hasErrors,
      formErrors
    } = this.state;

    return (
      <FormUi
        questions={questions}
        formValueByQuestionName={formValueByQuestionName}
        isSubmitted={isSubmitted}
        thankYouMessage={asset.thank_you_message}
        verticalAlign={verticalAlign}
        horizontalAlign={horizontalAlign}
        hasErrors={hasErrors}
        headerHtml={headerHtml}
        formErrors={formErrors}
        formId={formId}
        uniqueFormString={uniqueFormString}

        onQuestionChange={this.handleQuestionChange}
        onQuestionTouch={this.handleQuestionTouch}
        onFormSubmit={this.handleFormSubmit}
      />
    );
  }

  handleQuestionChange(question, newValue) {
    const formValueByQuestionName = cloneDeep(this.state.formValueByQuestionName);
    formValueByQuestionName[question.name].value = newValue;
    formValueByQuestionName[question.name].isTouched = true;

    this.setState(calcValidatedState(this.props.asset.id, {
      ...this.state,
      formValueByQuestionName
    }));
  }

  handleQuestionTouch(question) {
    const formValueByQuestionName = cloneDeep(this.state.formValueByQuestionName);
    formValueByQuestionName[question.name].isTouched = true;

    this.setState(calcValidatedState(this.props.asset.id, {
      ...this.state,
      formValueByQuestionName
    }));
  }

  handleFormSubmit(e) {
    e.preventDefault();

    const validatedState = calcValidatedState(this.props.asset.id, this.state, true);
    this.setState(validatedState);

    if (!validatedState.hasErrors) {
      this.props.onFormSubmit(getUserResponseFromState(validatedState), {
        onSuccess: () => {
          this.setState({
            ...this.state,
            isSubmitted: true
          });
        },
        onError: () => {
          alert('There was an error submitting your response. Please try again later.');
        },
      });
    }
  }

  generateQuestions(fields) {
    let formValueByQuestionName = {};
    const questions = [];

    each(fields, (field) => {
      const formValue = {
        value: '',
        error: false,
        isTouched: false,
      };

      if (field.type === FIELD_TYPE_MULTI_ANSWER) {
        formValue.value = [];
      }
      formValueByQuestionName[field.name] = formValue;
      const question = {
        name: field.name,
        label: field.label,
        placeholder: field.placeholder,
        type: field.type,
        isRequired: field.is_required || false,
        content: field.content || {},
      };
      if (question.type === FIELD_TYPE_SHORT_ANSWER) {
        question.legacyShouldHideLabel = field.legacyShouldHideLabel;
      }
      questions.push(question);
    });

    return { questions, formValueByQuestionName };
  }

  getStateConfig(asset){
    return {...calcValidatedState(asset.id, {
      ...this.generateQuestions(asset.fields),
      isSubmitted: false,
    })};
  }
}

GridTileInnerTypeForm.propTypes = {
  contentUuid: PropTypes.number.isRequired,
  headerHtml: PropTypes.string,
  asset: assetPropType.isRequired,
  pageId: PropTypes.number.isRequired,
  horizontalAlign: PropTypes.string,
  verticalAlign: PropTypes.string,
  onFormSubmit: PropTypes.func.isRequired
};

export default GridTileInnerTypeForm;

export const preventEnterKeyDownSubmit = (e) => {
  if (e.keyCode == 13) {
    e.preventDefault();
    return false;
  }
};

